import Toast from "../components/Toast/Toast"
import {toast} from 'react-toastify'

export const showToast = (message, type) => {
    toast(<Toast message={message} type={type}/>, {
        position: 'top-center'
    })
}